import { render } from "./SaveToBox.vue?vue&type=template&id=788da055&scoped=true"
import script from "./SaveToBox.vue?vue&type=script&lang=js"
export * from "./SaveToBox.vue?vue&type=script&lang=js"

import "./SaveToBox.vue?vue&type=style&index=0&id=788da055&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788da055"]])

export default __exports__